import { render, staticRenderFns } from "./CaptainsMap.vue?vue&type=template&id=68d708cb&scoped=true"
import script from "./CaptainsMap.vue?vue&type=script&lang=js"
export * from "./CaptainsMap.vue?vue&type=script&lang=js"
import style0 from "./CaptainsMap.vue?vue&type=style&index=0&id=68d708cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d708cb",
  null
  
)

export default component.exports